<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    //console.log("aaaa");
  },
  watch: {
  },
  methods: {
  },
  directives: {
  },
  filters: {
  },
};
</script>

<style>
html,body,p{
  margin: 0 !important;
  padding: 0;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, 微软雅黑, Tahoma, Arial, sans-serif;
}
img{
  max-width: 100%;
  height: auto;
}
table{
  border-collapse: collapse;
  border-spacing: 0;
}
#app {
  height: 100%;
}


/* 设置滚动条的样式 */
::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #C0C6CC;
    opacity: 0.6;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
    background-color: #F5F5F5;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background-color: rgb(192,198,207,0.6);
    border-radius:4px;
}
::-webkit-scrollbar-thumb:hover {
    background-color: rgb(192,198,207,1);
    border-radius:4px;
}
</style>
